<template>
  <div>
    <div v-if="isOnContactModal" class="flex flex-between">
      <sensitive-data-wrapper @click="openRecord(item.record_id)">
        <button-link
          v-if="item.record_id"
          @click="openRecord(item.record_id)"
        >{{ item.record_address }}
        </button-link>
      </sensitive-data-wrapper>

      <button-icon
        v-if="item.record_id"
        icon="edit"
        color="is-secondary"
        @click="openAttachCommLogModal(item)"
      ></button-icon>

      <button-link
        v-else
        icon="link-plus"
        @click="openAttachCommLogModal(item)"
      >Attach Lead</button-link>
    </div>

    <template v-if="isOnLeadModal">
      <button-link
        v-if="item.contact_id"
        @click="openContact(item.contact_id)"
      >{{ item.contact_name }}
      </button-link>
    </template>
  </div>
</template>

<script>
import {appendModal} from "../../services/modals";
import AttachCommunicationLogToLeadModal from "../../modules/comms/components/AttachCommunicationLogToLeadModal";
import router from "../../router";
import SensitiveDataWrapper from "../SensitiveDataWrapper.vue";

export default {
  name: "TimelineListColumn",
  components: {SensitiveDataWrapper},
  props: {
    item: {
      type: Object,
      required: true
    },
    isOnContactModal: {
      type: Boolean,
      default: false
    },
    isOnLeadModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openRecord(recordId) {
      this.$utils.closeContactModal();
      router.replace({query: {lead: recordId}});
    },
    openContact(contactId) {
      this.$utils.closeRecordModal();
      router.replace({query: {contact: contactId}});
    },
    openAttachCommLogModal(communicationLog) {
      appendModal(AttachCommunicationLogToLeadModal, this, {communicationLog: communicationLog});
    },
  }
};
</script>
